module.exports = __webpack_public_path__ + "img/edmbet-support.80f1d989.png";